// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__1SNyx","inputWrap":"Table_inputWrap__9VHo6","col":"Table_col__2QFdW","bmiTooltip":"Table_bmiTooltip__3bSfD"};